'use client';

import React from 'react';

import { Box, Divider, Flex, Grid, GridItem, HStack, Text, VStack } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

// import FbIcon from '@assets/FbIcon.svg';
import IgIcon from '@assets/IgIcon.svg';
import LinkedInIcon from '@assets/LinkedInIcon.svg';
import Logo from '@assets/Logo2.svg';
import XIcon from '@assets/XIcon.svg';
import { CustomText } from '@components/Custom-text';
import SocialPlatformIcon from '@components/nav-section/horizontal/SocialPlatformIcon';
import { UserType } from '@enums/index';
import { useAppDispatch, useAppSelector } from '@hooks/store';
import { setLogout } from '@modules/auth/lib/authSlice';
import { paths } from '@routes/path';

const Footer = () => {
    const { isAuthenticated, user } = useAppSelector(state => state.reducer.auth);
    const dispatch = useAppDispatch();
    const router = useRouter();

    function onClick() {
        if (isAuthenticated && user?.userType === UserType.Mentee) {
            dispatch(setLogout());
        }
        router.replace(paths.mentor.auth.signup);
    }
    return (
        <Box as="footer" color="white" px={8} pt={10} pb={4} bgColor="headerBg">
            <Grid templateColumns={{ base: '1fr', md: '2fr 5fr 5fr' }} gap={10} alignItems="center">
                <GridItem>
                    <VStack align="flex-start" spacing={4}>
                        <Link href={paths.general.home}>
                            <Image src={Logo} alt="logo" />
                        </Link>
                        <Flex gap={2}>
                            {/* <SocialPlatformIcon
                                src={FbIcon}
                                alt="Facebook"
                                href="https://facebook.com"
                            /> */}
                            <SocialPlatformIcon
                                src={IgIcon}
                                alt="Instagram"
                                href="https://instagram.com/youryoda_"
                            />
                            <SocialPlatformIcon
                                src={XIcon}
                                alt="Twitter"
                                href="https://www.x.com/company/your-yoda"
                            />
                            <SocialPlatformIcon
                                src={LinkedInIcon}
                                alt="LinkedIn"
                                href="https://www.linkedin.com/company/your-yoda"
                            />
                        </Flex>
                    </VStack>
                </GridItem>

                <GridItem>
                    <HStack spacing={6} wrap="wrap" align={{ base: 'flex-start', md: 'center' }}>
                        <Link href={paths.general.findMentor} passHref>
                            <Text
                                as="a"
                                color="primary.dark"
                                fontWeight={400}
                                fontSize="16px"
                                lineHeight="24px"
                            >
                                Find Mentors
                            </Text>
                        </Link>
                        <Text
                            onClick={() => onClick()}
                            color="primary.dark"
                            fontWeight={400}
                            fontSize="16px"
                            lineHeight="24px"
                            cursor="pointer"
                        >
                            Become a Mentor
                        </Text>
                        <Link href={paths.general.contact} passHref>
                            <Text
                                as="a"
                                color="primary.dark"
                                fontWeight={400}
                                fontSize="16px"
                                lineHeight="24px"
                            >
                                Contact
                            </Text>
                        </Link>
                        <Link href={paths.general.privacy} passHref>
                            <Text
                                as="a"
                                color="primary.dark"
                                fontWeight={400}
                                fontSize="16px"
                                lineHeight="24px"
                            >
                                Privacy Policy
                            </Text>
                        </Link>
                        <Link href={paths.general.termsandconditions} passHref>
                            <Text
                                as="a"
                                color="primary.dark"
                                fontWeight={400}
                                fontSize="16px"
                                lineHeight="24px"
                            >
                                Terms & Conditions
                            </Text>
                        </Link>
                        <Link href={paths.general.howItWorks} passHref>
                            <Text
                                as="a"
                                color="primary.dark"
                                fontWeight={400}
                                fontSize="16px"
                                lineHeight="24px"
                            >
                                FAQ&#39;s
                            </Text>
                        </Link>
                    </HStack>
                </GridItem>

                <GridItem>
                    <VStack align="flex-start" spacing={2}>
                        <CustomText color="primary.dark" weight={600}>
                            About Us
                        </CustomText>
                        <CustomText color="mainText" size="sm" textAlign="left">
                            We’re a purpose-driven community working to bridge the gap between raw
                            talent and the opportunities it deserves. From a small, passionate team,
                            we’ve grown into a movement that believes the right mentorship should be
                            accessible to anyone, anywhere — empowering individuals to grow through
                            support, guidance, and shared wisdom.
                        </CustomText>
                    </VStack>
                </GridItem>
            </Grid>
            <Flex px={0} mt={4} width="100%">
                <Divider orientation="horizontal" colorScheme="gray" />
            </Flex>
            <Flex
                bgColor="headerBg"
                width="100%"
                py={5}
                justifyContent="center"
                alignItems="center"
            >
                <CustomText color="mainText" size="md">
                    © YourYoda, All rights reserved.
                </CustomText>
            </Flex>
        </Box>
    );
};

export default Footer;
